import { useEffect, useMemo, useState } from "react";
import ArrowLeftLineIcon from "remixicon-react/ArrowLeftLineIcon";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Papa from "papaparse";
import CheckLineIcon from "remixicon-react/CheckLineIcon";
import CloseLineIcon from "remixicon-react/CloseLineIcon";
import DownloadCloud2sLineIcon from "remixicon-react/DownloadCloud2LineIcon";
import CardLayout from "../../../components/utils/CardLayout";
import Button from "../../../components/utils/Button";
import Table from "../../../components/utils/Table";
import { isKeyUnique, twoDigitDecimal } from "../../../helpers/commonFunction";
import authActions from "../../../redux/auth/actions";
import mdnSwapActions from "../../../redux/MDNSwap/actions";
import planAction from "../../../redux/plan/actions";

const { getUserDataByToken } = authActions;
const { createMdnSwapRequest } = mdnSwapActions;
const BASE_URL = process.env.REACT_APP_SITE_BASE_URL;
const { getPlan } = planAction;

const MDNForm = ({ back, search }) => {
  const dispatch = useDispatch();
  const { networkResult } = useSelector((state) => state.network);
  const {
    createMdnSwapError,
    createMdnSwapMessage,
    createMdnSwapLoading,
    getMdnSwapLoading,
  } = useSelector((state) => state.mdnSwap);

  // const { checkValidMsisdnData, checkValidMsisdnLoading } = useSelector(
  //   (state) => state.rechargeRequest);

  const [previewData, setPreviewData] = useState([]);
  const [activationRequests, setActivationRequests] = useState([]);
  const [networkId, setNetworkId] = useState(0);
  const { planResult } = useSelector((state) => state.plan);
  const [previewSuccessData, setPreviewSuccessData] = useState([]);
  const [previewFailedData, setPreviewFailedData] = useState([]);
  const [previewSuccessCount, setPreviewSuccessCount] = useState(0);
  const [selectedPlan, setSelectedPlan] = useState([]);
  const [showPreviewType, setShowPreviewType] = useState(2);

  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setError,
  } = useForm({
    defaultValues: {
      networkID: "",
      planID: "",
      purchaseAmount: 0,
      uploadedFile: "",
    },
  });

  const { register: registerFilter, setValue: setValueFilter } = useForm();

  const handleSelectPlan = (e) => {
    const planId = e.target.value;
    if (planId) {
      bulkActivationSetValue("planID", planId);
    }
    bulkActivationSetValue("uploadedFile", "");
    setPreviewData([]);
    setActivationRequests([]);
    setPreviewSuccessData([]);
    setPreviewFailedData([]);
    setPreviewSuccessCount(0);
    bulkActivationClearErrors(["uploadedFile"]);
  };

  const handlePreviewTableData = (id) => {
    setShowPreviewType(id);
  };

  const filteredNetworkResult = useMemo(() => {
    return networkResult?.filter((network) => network.ID == 4) || [];
  }, [networkResult]);

  const {
    register: bulkActivationRegister,
    formState: { errors: bulkActivationError },
    watch: bulkActivationWatch,
    setValue: bulkActivationSetValue,
    clearErrors: bulkActivationClearErrors,
  } = useForm({
    defaultValues: {
      networkID: "",
      planID: "",
      purchaseAmount: 0,
    },
  });

  const planIDWached = bulkActivationWatch("planID");
  const { tokenData } = useSelector((state) => state.auth);

  const [accountBalance, setAccountBalance] = useState(0);

  useEffect(() => {
    tokenData &&
      tokenData.length > 0 &&
      tokenData.map((data) => {
        setAccountBalance(data.AccountBalance);
      });
  }, [tokenData]);

  useEffect(() => {
    if (planResult?.length > 0 && networkResult?.length > 0) {
      setSelectedPlan(planResult);

      // Auto select first plan
      const firstPlan = planResult[0];

      if (firstPlan?.PlanID) {
        bulkActivationSetValue("planID", firstPlan.PlanID);
      }
    } else {
      setSelectedPlan([]);
      bulkActivationSetValue("planID", "");
    }
  }, [planResult, networkResult, bulkActivationSetValue]);

  useEffect(() => {
    if (networkResult?.length > 0) {
      const network = networkResult.find(
        (item) => item.IsActive == 1 && item.ID == 4,
      );

      if (network) {
        setValueFilter("networkID", String(network.ID));
      }
    }
  }, [networkResult, setValueFilter]);

  useEffect(() => {
    if (filteredNetworkResult.length > 0) {
      setNetworkId(4);
      bulkActivationSetValue("networkID", 4);
      dispatch(getPlan(4));
    }
  }, [filteredNetworkResult]);

  useEffect(() => {
    if (createMdnSwapError || createMdnSwapMessage) {
      back();
    }
  }, [createMdnSwapError, createMdnSwapMessage, back]);

  useEffect(() => {
    dispatch(getUserDataByToken());
  }, [dispatch]);

  // useEffect(() => {
  //   if (!checkValidMsisdnData || checkValidMsisdnData.length === 0) {
  //     return;
  //   }

  //   const newPreviewData = previewData.map((item) => {
  //     const result = checkValidMsisdnData.find(
  //       (item1) => item1.MSISDN === item.msisdn,
  //     );

  //     if (!result) {
  //       return item;
  //     }

  //     return {
  //       ...item,

  //       isValid: result.Status === 0 ? 0 : item.isValid,

  //       message: result.ExistStatus || item.message,
  //     };
  //   });

  //   setPreviewData(newPreviewData);

  //   const newRequestData = activationRequests.map((item) => {
  //     const result = checkValidMsisdnData.find(
  //       (item1) => item1.MSISDN === item.msisdn,
  //     );

  //     if (result && result.Status === 0) {
  //       return {
  //         ...item,
  //         status: 0,
  //         reason: result.ExistStatus,
  //       };
  //     }

  //     return item;
  //   });

  //   setActivationRequests(newRequestData);
  // }, [checkValidMsisdnData]);

  const handleFileChange = (e) => {
    clearErrors("uploadedFile");

    setPreviewData([]);
    setActivationRequests([]);

    const file = e.target.files?.[0];

    if (!file) {
      setError("uploadedFile", {
        type: "custom",
        message: "Csv is required!",
      });

      return;
    }

    const fileNameArr = file.name.split(".");
    const fileExt = fileNameArr[fileNameArr.length - 1];

    if (fileExt.toLowerCase() !== "csv") {
      setError("uploadedFile", {
        type: "custom",
        message: "Invalid file type. Only CSV file allowed.",
      });

      return;
    }

    const fileReader = new FileReader();

    fileReader.onload = ({ target }) => {
      const csvOutput = Papa.parse(target.result, {
        header: true,
        skipEmptyLines: true,
      });

      const parsedData = csvOutput?.data;

      if (!parsedData || parsedData.length === 0) {
        setError("uploadedFile", {
          type: "custom",
          message: "CSV file is empty.",
        });

        return;
      }

      if (parsedData.length > 100) {
        setError("uploadedFile", {
          type: "custom",
          message: "Maximum 100 rows are allowed",
        });

        return;
      }

      const columns = Object.keys(parsedData[0]);

      const specifiedColumns = ["MSISDN", "SERIAL NUMBER", "ZIPCODE"];

      const isValidCsvHeading =
        specifiedColumns.every((item) => columns.includes(item)) &&
        columns.length === specifiedColumns.length;

      if (!isValidCsvHeading) {
        setError("uploadedFile", {
          type: "custom",
          message:
            "Invalid CSV. Required columns: MSISDN, SERIAL NUMBER, ZIPCODE",
        });

        return;
      }

      const dataSource = parsedData.map((item) => {
        let error = false;
        let message = "";

        const msisdn = item.MSISDN?.trim();

        const serialNumber = item["SERIAL NUMBER"]?.trim();

        const zipcode = item.ZIPCODE?.trim();

        if (!msisdn) {
          error = true;
          message = "MSISDN is required";
        } else if (!/^\d{10}$/.test(msisdn)) {
          error = true;
          message = "MSISDN must be 10 digits";
        } else if (!serialNumber) {
          error = true;
          message = "Serial Number is required";
        } else if (!/^\d{19}$/.test(serialNumber)) {
          error = true;
          message = "Serial Number must be 19 digits";
        } else if (!zipcode) {
          error = true;
          message = "Zipcode is required";
        } else if (!/^\d{5}$/.test(zipcode)) {
          error = true;
          message = "Zipcode must be 5 digits";
        }

        return {
          msisdn,
          serialNumber,
          zipcode,
          isValid: error ? 0 : 1,
          message,
        };
      });

      if (!isKeyUnique(dataSource, "msisdn")) {
        setError("uploadedFile", {
          type: "custom",
          message: "Csv contains duplicate MSISDN",
        });

        return;
      }

      if (!isKeyUnique(dataSource, "serialNumber")) {
        setError("uploadedFile", {
          type: "custom",
          message: "Csv contains duplicate Serial Number",
        });

        return;
      }

      setPreviewData(dataSource);

      const requestData = dataSource.map((item) => {
        return {
          MSISDN: item.msisdn,
          SerialNumber: item.serialNumber,
          ZipCode: item.zipcode,
          status: item.isValid,
          reason: item.message,
        };
      });

      setActivationRequests(requestData);

      const validRows = dataSource.filter((item) => item.isValid === 1);

      if (validRows.length > 0) {
      }
    };

    fileReader.readAsText(file);
  };

  const estimatedAmountColumn = [
    { displayName: "Total MDN Swap", key: "tmdnSwap" },
    { displayName: "Per MDN Swap (Plan)", key: "pmdnSwap" },
    { displayName: "Total Paid", key: "tPaid" },
  ];

  const estimatedAmountDataSource = useMemo(() => {
    const totalActivation = previewData.filter(
      (item) => item.isValid === 1,
    ).length;

    if (!planIDWached) {
      return [
        {
          tmdnSwap: totalActivation,
          pmdnSwap: "$0.00",
          tPaid: "$0.00",
        },
      ];
    }

    const selectedPlan = planResult.find(
      (item) => Number(item.PlanID) === Number(planIDWached),
    );

    if (!selectedPlan) {
      return [
        {
          tmdnSwap: totalActivation,
          pmdnSwap: "$0.00",
          tPaid: "$0.00",
        },
      ];
    }

    const price = Number(selectedPlan.PlanPrice) || 0;

    const paidTotal = price * totalActivation;

    return [
      {
        tmdnSwap: totalActivation,
        pmdnSwap: `$${twoDigitDecimal(price)}`,
        tPaid: `$${twoDigitDecimal(paidTotal)}`,
      },
    ];
  }, [previewData, planIDWached, planResult]);

  const previewColumns = [
    {
      displayName: "MSISDN",
      key: "msisdn",
    },
    {
      displayName: "SERIAL NUMBER",
      key: "serialNumber",
    },
    {
      displayName: "ZIPCODE",
      key: "zipcode",
    },
    {
      displayName: "VALID",
      key: "Valid",
    },
    {
      displayName: "REASON",
      key: "errorReason",
    },
  ];

  const dataSource =
    previewData?.length > 0
      ? previewData.map((item) => {
          return {
            msisdn: item.msisdn,

            serialNumber: item.serialNumber,

            zipcode: item.zipcode,

            Valid:
              item.isValid === 1 ? (
                <CheckLineIcon color="#2ecc71" />
              ) : (
                <CloseLineIcon color="#e74c3c" />
              ),

            errorReason:
              item.isValid === 0 ? (
                <span
                  style={{
                    color: "#e74c3c",
                  }}
                >
                  {item.message}
                </span>
              ) : (
                ""
              ),
          };
        })
      : [];

  const downloadSampleFile = () => {
    const url = `${BASE_URL}/assets/csv/mdn-swap-sample-file.csv`;

    const link = document.createElement("a");

    link.href = url;

    link.download = "MDN Swap Sample File.csv";

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const handleAddRechargeRequest = (data) => {
    delete data.uploadedFile;

    const successCount = activationRequests.filter(
      (item) => item.status === 1,
    ).length;

    if (successCount <= 0) {
      alert("Invalid data for upload");
      return;
    }

    const selectedPlanData = planResult.find(
      (item) => Number(item.PlanID) === Number(planIDWached),
    );

    const planPrice = Number(selectedPlanData?.PlanPrice || 0);

    // Total amount
    const purchaseAmount = planPrice * successCount;

    const req = {
      ...data,
      networkID: networkId,
      planID: planIDWached,
      purchaseAmount: Number(purchaseAmount.toFixed(2)),
      requestData: activationRequests.map(
        ({ status, reason, ...item }) => item,
      ),
    };

    // "$20.00" -> 20
    const purchaseAmountNumber = Number(req.purchaseAmount);

    const balanceNumber = Number(accountBalance || 0);

    if (balanceNumber >= purchaseAmountNumber) {
      // console.log("Final Data:", req);
      dispatch(createMdnSwapRequest(req, search));
    } else {
      alert("Insufficient fund");
    }
  };

  const isSubmitDisabled =
    previewData.length === 0 ||
    getMdnSwapLoading ||
    previewData.some((item) => item.isValid !== 1);

  const hasValidData =
    previewData.length > 0 && previewData.every((item) => item.isValid === 1);

  return (
    <CardLayout title="MDN Swap">
      {/* Header */}
      <div className="row mb-3">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            onClick={downloadSampleFile}
            style={{
              background: "#2ecc71",
              color: "#fff",
              pointerEvents: "auto",
            }}
            className="btn font-weight-bold mr-2"
          >
            <DownloadCloud2sLineIcon size={16} />
            Sample File
          </button>

          <button
            type="button"
            onClick={back}
            className="btn btn-danger font-weight-bold"
          >
            <ArrowLeftLineIcon size={16} />
            Back
          </button>
        </div>
      </div>

      <div className="container">
        <form onSubmit={handleSubmit(handleAddRechargeRequest)}>
          {/* Upload CSV */}
          <div className="row mb-3">
            <div className="col-lg-3 col-md-4 mb-2">
              <label>Select Network</label>
              <span className="text-danger ml-1">*</span>
              <select
                className="form-control"
                id="networkID"
                {...registerFilter("networkID")}
              >
                {networkResult
                  ?.filter((item) => item.IsActive == 1 && item.ID == 4)
                  .map((item) => (
                    <option key={item.ID} value={item.ID}>
                      {item.NetworkName}
                    </option>
                  ))}
              </select>
              {errors && errors.networkID && (
                <div className="invalid-feedback">
                  {errors.networkID.message}
                </div>
              )}
            </div>

            <div className="col-md-3 mb-3">
              <label className="ml-2">
                {" "}
                Plan <span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                placeholder="Select Plan"
                name="planID"
                {...bulkActivationRegister("planID", {
                  required: "Plan is Required",
                })}
                onChange={(e) => handleSelectPlan(e)}
              >
                <option value="" disabled key="0">
                  Select
                </option>
                {selectedPlan &&
                  selectedPlan.length > 0 &&
                  selectedPlan.map((plan) => (
                    <option name="plan" value={plan.PlanID} key={plan.PlanID}>
                      {" "}
                      {plan.PlanName}{" "}
                    </option>
                  ))}
              </select>
              {bulkActivationError && bulkActivationError.planID && (
                <div className="invalid-feedback">
                  {bulkActivationError.planID.message}
                </div>
              )}
            </div>

            {/* UPLOAD FILE */}
            <div className="col-md-6">
              <label htmlFor="csvFile">
                Upload File<span className="text-danger ml-1">*</span>
              </label>

              <input
                type="file"
                className="form-control-file"
                name="uploadedFile"
                id="csvFile"
                accept=".csv"
                {...register("uploadedFile", {
                  required: "Csv is required",
                })}
                onChange={handleFileChange}
              />

              <small className="text-danger d-block">
                Note : Only 100 Rows are allowed
              </small>

              {errors?.uploadedFile && (
                <div className="invalid-feedback d-block">
                  {errors.uploadedFile.message}
                </div>
              )}
            </div>
          </div>

          {previewData.length > 0 && (
            <>
              <hr />

              <div className="col-md-12 mb-3 p-0 recharge-form-tble">
                <Table
                  columns={previewColumns}
                  loading={getMdnSwapLoading}
                  data={dataSource}
                  pagination={false}
                />
              </div>

              {hasValidData && (
                <div className="col-md-12 mb-3 p-0">
                  <h4>
                    <b>Price details</b>
                  </h4>

                  <Table
                    columns={estimatedAmountColumn}
                    loading={false}
                    data={estimatedAmountDataSource}
                    pagination={false}
                  />
                </div>
              )}
            </>
          )}

          <hr />

          {/* Footer */}
          <div className="text-right row">
            <div className="col-md-12">
              <button
                type="button"
                className="btn btn-secondary mr-2"
                onClick={back}
              >
                Close
              </button>

              <Button
                title="Submit"
                style={{
                  minWidth: "80px",
                }}
                disable={
                  previewData?.some((item) => item.isValid === 0) ||
                  previewData?.length === 0
                }
                loading={createMdnSwapLoading}
                buttonClass="btn btn-primary"
                buttonType="submit"
              />
            </div>
          </div>
        </form>
      </div>
    </CardLayout>
  );
};

export default MDNForm;
